export enum RequestsEndpoints {
    CrmRequests = "ux-gestion-de-incidentes-crm-pga/mep/servicio-al-cliente/v1/api/insureds/me/trackings",
}
